<input
    type="search"
    class="form-control rounded global-search-text-box"
    placeholder="{{'HOME.Search'| translate}}..."
    aria-label="Search"
    aria-describedby="search-addon"
    (keyup)="applyFilter($event.target.value)"
    [(ngModel)]="globalSearchText"
/>